import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const TalkingPointsPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "TalkingPointsPage" */ './Container'),
  'page'
);
